// src/pages/DanhGiaCuoiKy/FormDanhGia.js
import React, { useState, useEffect } from "react";
import { useToast } from "../../components/Toast/ToastContext";
import { XEP_LOAI_COLORS, XEP_LOAI_LABELS, NHAN_BAN_LABELS } from "./constants";

const GHI_CHU_NHANH = ['Chăm chỉ, có ý thức', 'Cần cố gắng hơn', 'Tiến bộ rõ rệt', 'Tích cực phát biểu', 'Cần chú ý học bài'];

const FormDanhGia = ({ hs, lopId, hocKy, existingData, calculateForHS, onSave, onClose, canEdit }) => {
  const { success, error } = useToast();
  const [loading, setLoading] = useState(false);
  const [calculating, setCalculating] = useState(true);
  const [form, setForm] = useState({
    nhanBan: '', nhanXet: '', xepLoai: '', thanhTichVanHoa: [],
    diemTB: null, chuyenCan: 0, soBuoiHoc: 0, soCoMat: 0, soVangKhongPhep: 0,
    goiYXepLoai: null, goiYLyDo: '', trangThai: 'nhapLieu',
    ketQua: 'lenLop', // ← THÊM: mặc định lên lớp
  });
  const [newThanhTich, setNewThanhTich] = useState('');
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (!hs) return;
    const fetchData = async () => {
      setCalculating(true);
      try {
        const result = await calculateForHS(hs.id);
        const base = {
          diemTB: result.diemTB, soBuoiHoc: result.tong, soCoMat: result.coMat,
          soVangKhongPhep: result.vangKP, chuyenCan: result.chuyenCan,
          goiYXepLoai: result.goiY?.loai, goiYLyDo: result.goiY?.lyDo,
        };
        if (existingData) {
          setForm({ ...base, nhanBan: existingData.nhanBan || '', nhanXet: existingData.nhanXet || '',
            xepLoai: existingData.xepLoai || '', thanhTichVanHoa: existingData.thanhTichVanHoa || [],
            trangThai: existingData.trangThai || 'nhapLieu',
            ketQua: existingData.ketQua || 'lenLop' });
        } else {
          setForm({ ...base, nhanBan: '', nhanXet: '', xepLoai: '', thanhTichVanHoa: [], trangThai: 'nhapLieu', ketQua: 'lenLop' });
        }
      } catch (err) { console.error(err); }
      finally { setCalculating(false); }
    };
    fetchData();
  }, [hs, existingData, calculateForHS]);

  const validate = () => {
    const errs = {};
    if (!form.nhanBan) errs.nhanBan = 'Vui lòng chọn nhân bản';
    if (!form.nhanXet || form.nhanXet.trim().length < 20) errs.nhanXet = 'Nhận xét tối thiểu 20 ký tự';
    if (!form.xepLoai) errs.xepLoai = 'Vui lòng chọn xếp loại';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSave = async (trangThai) => {
    if (trangThai === 'daHoanThanh' && !validate()) return;
    setLoading(true);
    const data = { ...form, trangThai, hocSinhId: hs.id, hocSinhTen: hs.hoTen, hocSinhTenThanh: hs.tenThanh || '', lopId, tenLop: '', namHoc: '2025-2026' };
    await onSave(hs.id, data);
    setLoading(false);
  };

  const addThanhTich = () => {
    if (!newThanhTich.trim()) return;
    setForm(p => ({ ...p, thanhTichVanHoa: [...p.thanhTichVanHoa, newThanhTich.trim()] }));
    setNewThanhTich('');
  };

  const chonGhiChuNhanh = (text) => {
    setForm(p => ({ ...p, nhanXet: p.nhanXet ? p.nhanXet + ' ' + text + '.' : text + '.' }));
  };

  if (calculating) return <div className="flex items-center justify-center py-8"><span className="material-symbols-outlined text-primary animate-spin text-3xl">sync</span><span className="ml-2">Đang tính toán...</span></div>;

  const duDieuKien = (form.diemTB || 0) >= 5 && form.chuyenCan >= 70 && form.soVangKhongPhep <= 3;

  return (
    <div className="space-y-4">
      {/* Thống kê tự động */}
      <div className="bg-surface-container-low rounded-xl p-4">
        <h4 className="text-body-md font-bold mb-2">📊 Kết quả học tập (tự động)</h4>
        <div className="flex flex-wrap gap-3 text-body-md">
          <span>ĐTB: <strong>{form.diemTB !== null ? form.diemTB : '—'}</strong></span>
          <span>CC: <strong>{form.chuyenCan}%</strong></span>
          <span>Vắng KP: <strong>{form.soVangKhongPhep}</strong></span>
          <span>Đi học: <strong>{form.soCoMat}/{form.soBuoiHoc} buổi</strong></span>
        </div>
        {form.goiYXepLoai && (
          <div className="mt-2 px-3 py-2 rounded-lg text-caption font-semibold" style={{background: XEP_LOAI_COLORS[form.goiYXepLoai]?.bg, color: XEP_LOAI_COLORS[form.goiYXepLoai]?.text}}>
            💡 Gợi ý: <strong>{XEP_LOAI_LABELS[form.goiYXepLoai]}</strong> · {form.goiYLyDo}
          </div>
        )}
      </div>

      {/* Nhân bản */}
      <div>
        <label className="text-label-caps font-bold text-on-surface-variant block mb-1">Nhân bản *</label>
        <div className="flex gap-2">
          {Object.entries(NHAN_BAN_LABELS).map(([key, label]) => (
            <button key={key} onClick={() => { setForm(p => ({ ...p, nhanBan: key })); setErrors(p => ({ ...p, nhanBan: '' })); }}
              className={`px-4 py-2 rounded-full text-caption font-bold transition-colors ${form.nhanBan === key ? 'bg-primary text-on-primary' : 'bg-surface border border-outline-variant'}`}>{label}</button>
          ))}
        </div>
        {errors.nhanBan && <p className="text-caption text-error mt-1">{errors.nhanBan}</p>}
      </div>

      {/* Nhận xét */}
      <div>
        <label className="text-label-caps font-bold text-on-surface-variant block mb-1">Nhận xét *</label>
        <textarea rows={4} value={form.nhanXet} onChange={e => { setForm(p => ({ ...p, nhanXet: e.target.value })); setErrors(p => ({ ...p, nhanXet: '' })); }}
          placeholder="Nhận xét về quá trình học tập..." className="w-full px-3 py-2.5 bg-surface border border-outline-variant rounded-xl text-body-md outline-none focus:ring-2 focus:ring-primary" />
        <div className="flex justify-between text-caption text-on-surface-variant mt-1"><span>{form.nhanXet.length}/500</span>{errors.nhanXet && <span className="text-error">{errors.nhanXet}</span>}</div>
        <div className="flex flex-wrap gap-1 mt-2">
          {GHI_CHU_NHANH.map((text, i) => (
            <button key={i} onClick={() => chonGhiChuNhanh(text)} className="px-2 py-1 rounded-full text-label-caps bg-surface-container hover:bg-surface-container-high">+ {text}</button>
          ))}
        </div>
      </div>

      {/* Xếp loại */}
      <div>
        <label className="text-label-caps font-bold text-on-surface-variant block mb-1">Xếp loại cuối kỳ *</label>
        <div className="grid grid-cols-2 gap-2">
          {Object.entries(XEP_LOAI_LABELS).map(([key, label]) => (
            <button key={key} onClick={() => { setForm(p => ({ ...p, xepLoai: key })); setErrors(p => ({ ...p, xepLoai: '' })); }}
              className={`p-3 rounded-xl text-body-md font-bold border-2 transition-all ${form.xepLoai === key ? '' : 'border-outline-variant'}`}
              style={form.xepLoai === key ? { borderColor: XEP_LOAI_COLORS[key]?.text, background: XEP_LOAI_COLORS[key]?.bg, color: XEP_LOAI_COLORS[key]?.text } : {}}>
              {label}{form.goiYXepLoai === key && <span className="ml-2 text-label-caps">💡</span>}
            </button>
          ))}
        </div>
        {errors.xepLoai && <p className="text-caption text-error mt-1">{errors.xepLoai}</p>}
      </div>

      {/* Kết quả lên lớp - THÊM MỚI */}
      <div>
        <label className="text-label-caps font-bold text-on-surface-variant block mb-1">Kết quả *</label>
        <div className="flex gap-2">
          <button onClick={() => setForm(p => ({ ...p, ketQua: 'lenLop' }))}
            className={`flex-1 py-3 rounded-xl font-bold text-body-md transition-all ${
              form.ketQua === 'lenLop' ? 'bg-green-500 text-white shadow-lg' : 'bg-surface border border-outline-variant text-on-surface-variant'
            }`}>
            ✅ Lên lớp
          </button>
          <button onClick={() => setForm(p => ({ ...p, ketQua: 'luuBan' }))}
            className={`flex-1 py-3 rounded-xl font-bold text-body-md transition-all ${
              form.ketQua === 'luuBan' ? 'bg-red-500 text-white shadow-lg' : 'bg-surface border border-outline-variant text-on-surface-variant'
            }`}>
            ❌ Lưu ban
          </button>
        </div>
      </div>

      {/* Thành tích */}
      <div>
        <label className="text-label-caps font-bold text-on-surface-variant block mb-1">Thành tích văn hoá</label>
        {form.thanhTichVanHoa.map((tt, i) => (
          <div key={i} className="flex items-center justify-between px-3 py-2 bg-surface-container rounded-lg mb-1">
            <span className="text-body-md">📚 {tt}</span>
            <button onClick={() => setForm(p => ({ ...p, thanhTichVanHoa: p.thanhTichVanHoa.filter((_, j) => j !== i) }))} className="text-error">✕</button>
          </div>
        ))}
        <div className="flex gap-2">
          <input value={newThanhTich} onChange={e => setNewThanhTich(e.target.value)} placeholder="Nhập thành tích..." onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), addThanhTich())}
            className="flex-1 px-3 py-2 bg-surface border border-outline-variant rounded-xl text-body-md outline-none" />
          <button onClick={addThanhTich} className="px-4 py-2 bg-secondary-container text-on-secondary-container rounded-xl text-body-md font-bold">+ Thêm</button>
        </div>
      </div>

      {/* Điều kiện */}
      <div className={`p-3 rounded-xl text-body-md font-semibold ${duDieuKien ? 'bg-green-50 text-green-700' : 'bg-yellow-50 text-yellow-700'}`}>
        {duDieuKien ? '✅ Đủ điều kiện lên lớp' : `⚠️ Chưa đủ điều kiện · ${form.chuyenCan < 70 ? `CC ${form.chuyenCan}%` : form.soVangKhongPhep > 3 ? `Vắng KP ${form.soVangKhongPhep}` : `ĐTB ${form.diemTB}`}`}
      </div>

      {/* Buttons */}
      {canEdit && (
        <div className="flex gap-2 pt-2 border-t border-outline-variant">
          <button onClick={() => handleSave('nhapLieu')} disabled={loading}
            className="flex-1 py-2.5 bg-surface border border-outline-variant rounded-xl text-body-md font-semibold">Lưu nháp</button>
          <button onClick={() => handleSave('daHoanThanh')} disabled={loading}
            className="flex-1 py-2.5 bg-primary text-on-primary rounded-xl text-body-md font-semibold">{loading ? '⏳...' : '✅ Hoàn thành'}</button>
        </div>
      )}
    </div>
  );
};

export default FormDanhGia;